import { getMessaging, getToken, onMessage } from "@firebase/messaging";

import { Icons } from "components";
// @ts-ignore
import NotifSound from "assets/sounds/notif.mp3";
import React from "react";
import { initializeApp } from "firebase/app";
import { notification } from "antd";

const firebaseConfig = {
	apiKey: "AIzaSyAarz8EfGFCymn1KnZrEFICCjxOip_hVXw",
	authDomain: "team24-91b69.firebaseapp.com",
	projectId: "team24-91b69",
	storageBucket: "team24-91b69.appspot.com",
	messagingSenderId: "788118435610",
	appId: "1:788118435610:web:5df60dd0da13cefeb35ea3",
	measurementId: "G-CGVK4LTLGW"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// foreground messaging
onMessage(messaging, (payload) => {
	let data = payload.data || {};

	let icon = <Icons.Bell />;

	if (data?.notifType === "chat" || data?.notifType === "message") {
		icon = <Icons.ChatFilled color />;
	} else if (data?.notifType === "consultation") {
		icon = <Icons.Calendar color />;
	}

	if (data?.notifType === "message") {
		if (window.location?.pathname !== "/chat") {
			notification.close("message");

			notification.open({
				key: "message",
				message: data.title,
				description: data.body,
				placement: "topRight",
				duration: 0,
				icon
			});
		} else {
			return;
		}
	} else {
		notification.open({
			message: data.title,
			description: data.body,
			placement: "topRight",
			duration: 0,
			icon
		});
	}

	const audio = new Audio(NotifSound);
	audio.play();
});

export const getFirebaseToken = async () => {
	let currentToken = "";

	try {
		currentToken = await getToken(messaging, {
			vapidKey: "BETnyBUBMON2A6Rjhbe-s-zvPo1IQgN8li6dy7Drx-zji1UNYvHPWo8_qk78yxAJAEh4IFUCNX3wqUMNnfHT534"
		});
	} catch (err) {
		console.log("An error occurred while retrieving token. ", err);
	}

	return currentToken;
};
